import getDiffInMinutes from './getDiffInMinutes';
export default getDiffInMinutes;
